import { Options } from 'src/app/shared/models/lookup-master/lookup-master.model';

export class LookUpResourceModel {
  constructor() {
    this.QuestionNumber = '';
    this.QuestionKey = '';
    this.QuestionText = '';
    this.Title = '';
    this.ToolTip = '';
    this.HasDependents = true;
    this.Dependents = null;
    this.TemplateName = '';
    this.IsEditable = true;
    this.IsVisible = false;
    this.NextQuestionKey = '';
    this.PreviousQuestionKey = '';
    this.SectionName = '';
    this.Risk = '';
    this.RiskNode = '';
    this.Options = [];
    this.IsValid = true;
  }
  QuestionNumber: string;
  QuestionKey: string;
  QuestionText: string;
  Title: string;
  ToolTip: string;
  HasDependents: boolean;
  Dependents: string | null;
  TemplateName: string;
  IsEditable: boolean;
  IsVisible: boolean;
  NextQuestionKey: string;
  PreviousQuestionKey: string;
  SectionName: string;
  Risk: string;
  RiskNode: string;
  Options: Options[];
  IsValid: boolean;
}
